import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ITableau } from '../models/interfaces/ITableau';

const { apiUrl } = environment;

@Injectable({
  providedIn: 'root',
})
export class TableauService {
  constructor(private http: HttpClient) {}

  get(): Promise<ITableau> {
    const response = this.http.get<ITableau>(`${apiUrl}tableau`).toPromise();
    return response;
  }

  getTrustedTicket(): Promise<string> {
    const ticket = this.http
      .get<string>(`${apiUrl}tableau/trusted-ticket`, {
        responseType: 'text' as 'json',
      })
      .toPromise();
    return ticket;
  }
}
